<template>
  <div class="header"> 
    <div class="headerinfo">
      <div class="toptip">{{ datetime }}
        <div class="info-seach">
          <el-input 
            class="inline-input" 
            v-model="inputinfo" 
            placeholder="请输入关键字">
            
            <button @click="handleSearch" class="seachbtn" slot="suffix"><i
              class="iconfont icon-sousuo" style="font-size:20px;margin-right: 8px;">
            </i>搜索</button>
            </el-input>
          </div>
        </div>
      <img class="logo" :src="logopic()?`${IP_TEST}/uploads/${logopic()}`:'/static/img/logo.png'" alt="" />
      <!-- <img class="biaoyu" src="/static/img/biaoyu.png" alt="" /> -->
      </div>
  </div>
  
</template>

<script>
import { IP_TEST } from '@/config';


import {logoutUser} from '@/request/get'
export default {
  name: "Header",
  data() {
    return {
      timer:'',
      IP_TEST: IP_TEST,
      inputinfo: "",
      restaurants: [],
      queryInfo: null,
      datetime:"",
      list: [
        {
          id: "1",
          "value": "声学软件",
          type: "view",
          path: '/news/views/'
        },
        {
          id: "2",
          "value": "噪声治理",
          type: "view",
          path: '/news/views/'
        },
        {
          id: "3",
          "value": "振动控制",
          type: "view",
          path: '/news/views/'
        },
        {
          id: "4",
          "value": "产品展示",
          type: "view",
          path: '/news/views/'
        },
        {
          id: "5",
          "value": "培训交流",
          type: "view",
          path: '/news/views/'
        }
      ]
    }
  },
  computed: {
   
  },
  methods: {
    logopic() {
      return this.$store.getters.logopic;
    },
    user() {
      return this.$store.getters.user;
    },
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) != -1);
      };
    },
    loadAll() {
      let { plates } = this.$store.state;
      this.list = this.list.map((item) => {
        let plate = plates.find(plate => plate.name.replace("T", "") == item.value);
        plate && (item['uuid'] = plate.uuid);
        return item;
      });
      return this.list;
    },
    handleSelect(item) {
      this.queryInfo = item;
    },
    handleSearch() {
      if (this.queryInfo&&this.queryInfo.value == this.inputinfo) {
        this.$router.push('' + this.queryInfo.path + this.queryInfo.uuid);
      }
      if (this.inputinfo) {
        let result = this.list.filter(item => item.value == this.inputinfo)
        if (result.length === 0) {
          this.$router.push({
            path: '/news/views/search',
            query: {
              keyWords: this.inputinfo
            }
          });
        } else {
          this.$router.push('' + result[0].path + result[0].uuid);
        }
      }
    },
    // 格式化日对象
     getNowDate(){
      var date = new Date();
      var sign2 = ":";
      var year = date.getFullYear() // 年
      var month = date.getMonth() + 1; // 月
      var day = date.getDate(); // 日
      var hour = date.getHours(); // 时
      var minutes = date.getMinutes(); // 分
      var seconds = date.getSeconds() //秒
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (day >= 0 && day <= 9) {
        day = "0" + day;
      }
      if (hour >= 0 && hour <= 9) {
        hour = "0" + hour;
      }
      if (minutes >= 0 && minutes <= 9) {
        minutes = "0" + minutes;
      }
      if (seconds >= 0 && seconds <= 9) {
        seconds = "0" + seconds;
      }
      return year + "年" + month + "月" + day + "日 " + hour + sign2 + minutes + sign2 + seconds;
    }

  },
  mounted() {
    this.restaurants = this.loadAll();
    this.timer = setInterval(
      ()=>{
        this.datetime = this.getNowDate();
      },1000
    )
  },
  beforeDestroy(){
    clearInterval(this.timer);
  }
};
</script>
<style scoped>
.header{
  height: 467px;
  width: 100%; 
  background-image: url(/static/img/bg.png);
  background-repeat: no-repeat;
  background-size: cover;
}
.headerinfo{
  height: 467px;
  width: 1300px;
  margin: auto;
}
.headerinfo .time{
  float: right;
}
.headerinfo .toptip{
  width: 100%;
  font-size: 18px;
  /* font-family: Inter-Regular, Inter; */
  font-weight: 400;
  color: #FFFFFF;
  line-height: 61px;
  -webkit-background-clip: text;
  position: relative;
  top: 61px;
}
.headerinfo .logo{
  margin: auto;
  width: 1014px;
  position: relative;
  top:126px;
  /* display: block; */
}
.biaoyu{
  margin: auto;
  width: 391px;
  position: relative;
  top:156px;
  display: block;
  float:right;
}
.info-seach{
  position: relative;
  /* top:142px; */
  /* margin: auto; */
  width: 388px;
  display: inline-block;
  float: right;
  height: 60px;
background-color:rgba(255,255,255,0.2);
border-radius: 30px;
text-align:center;
line-height: 60px;
}
.info-seach .inline-input{
  width: 378px;
  height: 50px;


}
.info-seach .inline-input >>>.el-input__inner{
  /* border:solid 2px #579BF1; */
  border-radius: 6px;
  height: 50px;
  line-height: 50px;
  font-size: 16px;
  background-color:rgba(255,255,255,0.42);
color: #FFFFFF;
border: 0px;
border-radius: 25px;
}
.info-seach .inline-input  >>>.el-input__inner{
  padding-left: 20px;
}
.info-seach .inline-input >>> .el-input__prefix{
    height: 50px;
    line-height: 50px;
    font-size: 18px;
    padding: 0 10px 0 10px;
}
.seachbtn{
  width: 92px;
  height: 42px;
  background: #266FF5;
  border-radius: 21px;
  color: #fff;
  font-size: 18px;
}

</style>
